<script>
import { mapState, mapActions } from 'vuex';
/* components */
import FullScreenOverlay from '@/components/FullScreenOverlay';
import Button from '@/components/Button';
import InputBlock from '@/components/InputBlock';

/* tools */
import { onboardingBackground } from '@/scripts/computed';
import { goTo } from '@/scripts/methods';
import { getPlatformIconUrl } from '@/scripts/utils/data';

export default {
  name: 'SpecifyGame',
  components: {
    Button,
    FullScreenOverlay,
    InputBlock,
  },
  props: {
    setup: {
      type: Object,
      required: true,
    },
    activeGame: {
      type: String,
      required: true,
    },
    platform: {},
    userInput: {
      type: String,
    },
    linkTo: {
      type: String,
      default: '/onboarding/connect-game',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),

    onboardingBackground,
  },
  created() {
    const { activeGame, setup } = this;

    if (!activeGame || !setup)
      this.$router.push({
        name: 'Onboarding',
        params: { option: 'connect-game', errorState: true },
      });
  },
  mounted() {},
  methods: {
    ...mapActions({}),
    checkValidAction() {
      const { userInput, linkTo } = this;

      if (!userInput) return;

      this.goTo(linkTo);
    },
    goTo,
    getPlatformIconUrl,
  },
};
</script>

<template>
  <FullScreenOverlay
    :style="onboardingBackground"
    :class="{ shadowBg: onboardingBackground }"
  >
    <div class="onboarding">
      <div class="onboarding__top">
        <Button :back="true" class="back">
          <template #icon>
            <img :src="require(`@/assets/svg/arrow-left.svg`)" />
          </template>
        </Button>
        <div class="onboarding__logo">
          <img :src="getPlatformIconUrl(platform)" />
        </div>
      </div>
      <div class="onboarding__body">
        <div class="onboarding__row onboarding__row--head">
          <h1 class="onboarding__title">
            {{ setup.accountForm.title }}
          </h1>
        </div>
        <div class="onboarding__row onboarding__row--input">
          <InputBlock
            :placeholder="setup.accountForm.inputPlaceholder"
            :autofocus="true"
            @input="val => $emit('at-input', val)"
            @enter="checkValidAction"
          >
            <template #linkTop>
              <Button
                :href="setup.accountForm.linkURL || '/'"
                class="link-white sm-m"
              >
                {{ setup.accountForm.linkText }}
              </Button>
            </template>
          </InputBlock>
        </div>
        <div class="onboarding__row onboarding__row--btn">
          <Button
            :to="linkTo"
            :disabled="!userInput"
            class="blue default m-290"
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  </FullScreenOverlay>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.onboarding {
  &__top {
    margin-bottom: 12px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
  }

  &__logo {
    display: flex;

    img {
      display: flex;
      max-height: 40px;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    width: 100%;
    flex-grow: 1;
  }

  &__title {
    font-family: Sen-Bold;
    font-size: 36px;
    line-height: 43px;
    text-transform: uppercase;
    color: #ffc800;
    text-align: center;
    margin: 0;
  }

  &__row {
    &--head + &--input {
      margin-top: 70px;
    }

    &--input {
      width: 100%;
      max-width: 570px;
      margin-left: auto;
      margin-right: auto;
      flex-shrink: 0;
    }

    & + &--btn {
      margin-top: 50px;
    }

    &--btn {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
    }
  }
}

@media (max-width: $mobile) {
  .onboarding {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;

    &__top {
      min-height: 29px;
      margin-bottom: 30px;
      flex-shrink: 0;
    }

    &__logo {
      img {
        max-height: 28px;
      }
    }

    &__title {
      font-size: 24px;
      line-height: 1.28;
    }

    &__row {
      &--head + &--input {
        margin-top: 75px;
      }

      &--btn {
        flex-grow: 1;
        align-items: flex-end;
      }
    }
  }
}
</style>
